import {
    Card,
    CardHeader,
    CardFooter,
    Table,
    Container,
    Row,
    Col,
    Button,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
} from "reactstrap";
import { useState } from "react";
import { useSetUserReferralLimit } from "lib/api-referral";

const ReferralTable = ({ usersData, onRefresh, showAlert }) => {
    const { mutate: setReferralLimitMutation } = useSetUserReferralLimit();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [modal, setModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [newLimit, setNewLimit] = useState("");

    const itemsPerPage = 10;

    const filteredData = usersData.filter((user) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(searchLower)) ||
            (user.email && user.email.toLowerCase().includes(searchLower)) ||
            (user.userId &&
                user.userId.toString().toLowerCase().includes(searchLower))
        );
    });

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentData = filteredData.slice(startIndex, endIndex);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const toggleModal = () => {
        setModal(!modal);
        if (!modal) {
            setSelectedUser(null);
            setNewLimit("");
        }
    };

    const openLimitModal = (user) => {
        setSelectedUser(user);
        setNewLimit(user.referralLimit?.toString() || "0");
        setModal(true);
    };

    const handleSetLimit = () => {
        if (selectedUser && newLimit !== "") {
            const limitValue = parseInt(newLimit);
            if (isNaN(limitValue) || limitValue < 0) {
                showAlert(
                    "Please enter a valid limit (0 or greater)",
                    "danger"
                );
                return;
            }

            console.log(limitValue, "LIMIT ")

            setReferralLimitMutation(
                {
                    id: selectedUser.userId,
                    limit: { limit: limitValue },
                },
                {
                    onSuccess: () => {
                        showAlert(
                            `Referral limit updated for ${
                                selectedUser.email || selectedUser.name
                            }`,
                            "success"
                        );
                        setTimeout(() => {
                            onRefresh();
                        }, 1000);
                        toggleModal();
                    },
                    onError: (error) => {
                        showAlert(
                            `Failed to update referral limit: ${error.message}`,
                            "danger"
                        );
                    },
                }
            );
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    return (
        <Container className="mt-4" fluid>
            <Row>
                <div className="col">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <Row className="align-items-center">
                                <Col xs="8">
                                    <h3 className="mb-0">
                                        User Referral Management
                                    </h3>
                                </Col>
                                <Col xs="4" className="text-right">
                                    <Button
                                        color="primary"
                                        size="sm"
                                        onClick={onRefresh}
                                    >
                                        <i className="fas fa-sync-alt" />{" "}
                                        Refresh
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="6">
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="fas fa-search" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Search by email, username, or ID..."
                                            type="text"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </InputGroup>
                                </Col>
                            </Row>
                        </CardHeader>

                        <Table
                            className="align-items-center table-flush"
                            responsive
                        >
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">User ID</th>
                                    <th scope="col">Referrals Limit</th>
                                    <th scope="col">Referrals Count</th>
                                    <th scope="col">Rewards</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentData.length > 0 ? (
                                    currentData.map((user, index) => (
                                        <tr key={user.userId || index}>
                                            <td>
                                                <span className="text-sm">
                                                    {user.name || "N/A"}
                                                </span>
                                            </td>
                                            <td>
                                                <div>
                                                    <span className="text-sm font-weight-bold">
                                                        {user.email || "N/A"}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="text-sm font-weight-bold">
                                                    {user.userId || "N/A"}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="text-sm font-weight-bold">
                                                    {user.referredLimit || 0}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="text-sm font-weight-bold">
                                                    {user.referredCount || 0}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="text-sm">
                                                    {user.reward || "0"}
                                                </span>
                                            </td>

                                            <td>
                                                <Button
                                                    color="primary"
                                                    size="sm"
                                                    onClick={() =>
                                                        openLimitModal(user)
                                                    }
                                                >
                                                    <i className="fas fa-edit" />{" "}
                                                    Set Limit
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            className="text-center py-4"
                                        >
                                            <div className="text-muted">
                                                <i className="fas fa-users fa-2x mb-2" />
                                                <p>
                                                    {searchTerm
                                                        ? "No users found matching your search"
                                                        : "No users found"}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        {filteredData.length > 0 && (
                            <CardFooter className="py-4">
                                <nav aria-label="User referrals pagination">
                                    <ul className="pagination justify-content-end mb-0">
                                        <li
                                            className={`page-item ${
                                                currentPage === 1
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage - 1
                                                    )
                                                }
                                                disabled={currentPage === 1}
                                            >
                                                <i className="fas fa-angle-left" />
                                                <span className="sr-only">
                                                    Previous
                                                </span>
                                            </button>
                                        </li>

                                        {Array.from(
                                            { length: totalPages },
                                            (_, i) => i + 1
                                        ).map((page) => (
                                            <li
                                                key={page}
                                                className={`page-item ${
                                                    page === currentPage
                                                        ? "active"
                                                        : ""
                                                }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        handlePageChange(page)
                                                    }
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${
                                                currentPage === totalPages
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage + 1
                                                    )
                                                }
                                                disabled={
                                                    currentPage === totalPages
                                                }
                                            >
                                                <i className="fas fa-angle-right" />
                                                <span className="sr-only">
                                                    Next
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>

                                <div className="text-muted text-sm mt-2">
                                    Showing {startIndex + 1} to{" "}
                                    {Math.min(endIndex, filteredData.length)} of{" "}
                                    {filteredData.length} entries
                                    {searchTerm &&
                                        ` (filtered from ${usersData.length} total)`}
                                </div>
                            </CardFooter>
                        )}
                    </Card>
                </div>
            </Row>

            {/* Set Referral Limit Modal */}
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Set Referral Limit
                </ModalHeader>
                <ModalBody>
                    {selectedUser && (
                        <div>
                            <p>
                                <strong>User:</strong>{" "}
                                {selectedUser.email || selectedUser.name}
                            </p>
                            <p>
                                <strong>Current Referrals:</strong>{" "}
                                {selectedUser.referredCount || 0}
                            </p>
                            <p>
                                <strong>Current Limit:</strong>{" "}
                                {selectedUser.referralLimit || "No Limit"}
                            </p>

                            <Form>
                                <FormGroup>
                                    <Label for="referralLimit">
                                        New Referral Limit
                                    </Label>
                                    <Input
                                        type="number"
                                        id="referralLimit"
                                        placeholder="Enter referral limit (0 for no limit)"
                                        value={newLimit}
                                        onChange={(e) =>
                                            setNewLimit(e.target.value)
                                        }
                                        min="0"
                                    />
                                    <small className="form-text text-muted">
                                        Set to 0 to remove the limit
                                    </small>
                                </FormGroup>
                            </Form>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSetLimit}>
                        Update Limit
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default ReferralTable;
